const state = () => ({
    studentConstant:[
      { key: "selection",
        prop:'selection',
        type: "selection",
        width: "30",
        isShow:true,
        canWeControlIt:false,
        rowName:'复选框'
      },
      {
        key: "headImage",
        align: "center",
        width: "45",
        prop: "headImage",
        fixed: "left",
        slot: "headImage",
        isShow:true,
        rowName:'头像',
        canWeControlIt:false
      },
      {
        label: "学员姓名",
        rowName:'学员姓名',
        key: "name",
        minWidth: "210",
        prop: "name",
        showOverflowTooltip:true,
        fixed: "left",
        slot: "name",
        isShow:true,
        canWeControlIt:true,
      },
      {
        key: "arrearsFlag",
        rowName:'欠费标识',
        align: "center",
        width: "45",
        prop: "arrearsFlag",
        fixed: "left",
        isShow:true,
        canWeControlIt:false,
        slot: "arrearsFlag",
      },
      {
        label: "联系方式",
        rowName:'联系方式',
        key: "phoneNumber",
        minWidth: "160",
        prop: "phoneNumber",
        isShow:true,
        canWeControlIt:true,
        slot: "phoneNumber",
      },
      {
        label: "绑定学员端",
        rowName:'绑定学员端',
        key: "bindToCollegeEnd",
        width: "100",
        prop: "bindToCollegeEnd",
        isShow:true,
        canWeControlIt:true,
        slot: "bindToCollegeEnd",
      },{
        label: "人脸采集",
        rowName:'人脸采集',
        key: "faceId",
        width: "100",
        prop: "faceId",
        isShow:true,
        canWeControlIt:true,
        slot: "faceId",
      },
      {
        label: "就读学校",
        rowName:'就读学校',
        key: "schoolName",
        prop: "schoolName",
        minWidth: "140",
        isShow:true,
        showOverflowTooltip:true,
        canWeControlIt:true,
        slot: "schoolName",
      },
      {
        label: "班级名称",
        rowName:'班级名称',
        key: "className",
        prop: "className",
        minWidth: "140",
        showOverflowTooltip:true,
        slot:"className",
        isShow:true,
        canWeControlIt:true,
      },
      {
        label: "课程",
        rowName:'课程',
        key: "courseName",
        prop: "courseName",
        minWidth:"140",
        showOverflowTooltip:true,
        isShow:true,
        canWeControlIt:true,
        slot:"courseName",
      },
      {
        label: "欠费金额(元)",
        rowName:'欠费金额',
        key: "arrearsAmount",
        width: "140",
        prop: "arrearsAmount",
        sortable: "custom",
        isShow:true,
        canWeControlIt:true,
        slot:"arrearsAmount",
      },
      {
        label: "就读年级",
        rowName:'就读年级',
        key: "currentGradeText",
        prop: "currentGradeText",
        width:"104",
        sortable: "custom",
        showOverflowTooltip:true,
        isShow:true,
        canWeControlIt:true,
        slot:"currentGradeText",
      },
      {
        label: "学员状态",
        rowName:'学员状态',
        key: "typeText",
        prop: "typeText",
        sortable: "custom",
        slot: "typeText",
        width: "150",
        isShow:true,
        canWeControlIt:true
      },
      {
        label: "联系人信息",
        rowName:'联系人信息',
        key: "realNameRelationShip",
        width:"140",
        showOverflowTooltip:true,
        prop: "realNameRelationShip",
        slot: "realNameRelationShip",
        isShow:true,
        canWeControlIt:true,
      },
      {
        label: "学员来源",
        rowName:'学员来源',
        width: "120",
        key: "studentSourceName",
        isShow:true,
        canWeControlIt:true,
        prop: "studentSourceName"
      },
      {
        label: "创建时间",
        rowName:'创建时间',
        key: "createTime",
        width: "150",
        prop: "createTime",
        sortable: "custom",
        fixed: "right",
        isShow:true,
        canWeControlIt:true,
        slot: "createTime",
      },
      {
        label: "操作",
        rowName:'操作',
        key: "operation",
        fixed: "right",
        align: "center",
        width: "55",
        slot: "operation",
        isShow:true,
        canWeControlIt:false,
      },
    ]
});

const mutations = {
  setTableListOptions(state, data) {
    state[data.constantName] = state[data.constantName].map((item,index) => {
      if( item.key === data.colSetting[index].key){
        item.isShow = data.colSetting[index].isShow;
      }
      return item;
    })
  },
};

const actions = {};

export default {
  namespaced: true,//
  state,
  actions,
  mutations,
};
